
export const PayApiPort = ({
    'Methods': '/api/Payment/Methods?',
    'DetailsDeposit': '/api/Payment/Method/Details?',
    'MemberBanks': '/api/Payment/MemberBanks?',
    'Member': '/api/Member?',
    'DepositPresignedUrls': '/api/Payment/Application/DepositPresignedUrls?',
    'UploadAttachments': '/api/Payment/Application/UploadAttachment?',
    'SuggestedAmounts': '/api/Payment/SuggestedAmounts?',
    'MemberCancelDeposit': '/api/Payment/Application/MemberCancelDeposit?', 
    'CryptocurrencyDetails': '/api/Payment/Cryptocurrency/Details?',
    'DepositAccountByAmount': '/api/Payment/DepositAccountByAmount?',
    'ConfirmStep': '/api/Payment/Application/ConfirmStep?',
    'AnnouncementPopup': '/api/Announcement/Popup?',
    'Application': '/api/Payment/Application?',
    'Bonus': '/api/Bonus/v2.0?'
})